import { EntityFileModel } from "./entity-file-model";

export class FileUploadModel {
    fileIdsToAdd: string[] = [];
    fileIdsToDelete: string[] = [];
    fileIds?: string[];

    //used to load and display files that are staged temporarily to non ID modals 
    entityFiles: EntityFileModel[] = []; 
}